<template>
  <account-settings></account-settings>
</template>

<script>
  import AccountSettings from "../components/account/AccountSettings";
  export default {
    name: 'account',
    components: {AccountSettings}
  }
</script>